
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { RouterModule } from '@angular/router';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { InvCondListComponent } from '../inv-cond-list/inv-cond-list.component';
import { InvCondSearchComponent } from '../inv-cond-search/inv-cond-search.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-inv-cond-list-search',
  templateUrl: './inv-cond-list-search.component.html',
  styleUrls: ['./inv-cond-list-search.component.css']
})
export class InvCondListSearchComponent implements OnInit {

  public menu_item_id = '39';
  public add_auth;
  public edit_auth;
  public del_auth;
  
  private dp = [];
  displayedColumns = ['list_name', 'list_name_en', 'view', 'edit', 'del'];
  dataSource = new MatTableDataSource(this.dp);
  addDialogRef: MatDialogRef<InvCondListComponent>;
  viewDialogRef: MatDialogRef<InvCondSearchComponent>;
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'inv_cond_list', 'cond_list_id': '0', 'list_name': '', 'list_name_en': '', 
    'comment': '' };

  Success_Msg; Error_Msg; Del_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);


    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Del_Msg').subscribe((res: string) => {
      this.Del_Msg = res;
    });

  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);
  }

  search() {
    //
    let condition = "";

    if (this.model['list_name'] != '')
      condition = "(`list_name` LIKE '%" + this.model['list_name'] + "%' OR `list_name_en` LIKE '%" + this.model['list_name'] + "%') AND ";

    let query = "SELECT * FROM `inv_cond_list` WHERE " + condition + " `status` = '1' AND (`branch_id` = '0' OR `branch_id` = '" + 
      this.applicationConstants.user_branch_info.user_branch_id + "')";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }
  
  newInvCondListEntry() {
    this.addDialogRef = this.dialog.open(InvCondListComponent, {
      hasBackdrop: false,
      //data: this.dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        // if (result != null && result['status'] == 'success')
        if (result != null && result['op_type'] == 'success')
          this.search();
        //console.log(this.acct_income);
      });
  }

  viewCond(row) {
    this.viewDialogRef = this.dialog.open(InvCondSearchComponent, {
      hasBackdrop: false,
      data: { cond_list_id: row.cond_list_id }
    });
    this.viewDialogRef
      .afterClosed()
      .subscribe(result => {

      });

  }

  editCondList(row) {
    let dialog_data = {
      'table_name': 'inv_cond_list', 'cond_list_id': row.cond_list_id, 'list_name': row.list_name,
      'list_name_en': row.list_name_en, 'branch_id': row.branch_id, 'comment': row.comment
    };
    this.addDialogRef = this.dialog.open(InvCondListComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.addDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success')
          this.search();
      });
  }

  delCondList(row) {
    if (confirm(this.Del_Msg)) {
      let values = [{ 'table_name': this.model['table_name'], 'cond_list_id': row.cond_list_id }];
      let obj = { cmd: 'deleteRec', values: values };

      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.search();
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
  }


}
